<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account/member")
          i.fa.fa-users
          span.ml-1 {{ $tc("ui.members", 2) }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')")
                div.row.col-md-9.mb-1
                  div(width="80%").mr-3
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="account_id") {{ $t("ui.account_id") }}
                      b-form-radio(value="full_name") {{ $t("ui.full_name") }}
                  div(width="20%")
                    SubmitButton(
                      :loading="loading"
                      icon="fa fa-search"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getMemberList(true)"
                      variant="success"
                      size="sm"
                      )
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.parent_id')") {{ $t("ui.parent_id") }}
                      th.sticky-position.sortable(@click="sortOrder('full_name')" width="10%")
                        span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                        i(:class="changeSortKey('full_name')")
                      th.sticky-position(width="10%")
                        span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                      th.sticky-position(width="9%")
                        span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                      th.sticky-position(width="10%")
                        span(:title="$t('ui.balance')") {{ $t("ui.balance") }}
                      th.sticky-position(width="8%")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                      th.text-center.sticky-position(width="18%" v-if="operatorDetail && operatorDetail.self_operate == true")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                      th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('created_date')")
                        span {{ $t("ui.created_date") }}
                        i(:class="changeSortKey('created_date')")
                  tbody.clusterize-content
                    tr(v-if="memberList.length == 0")
                      td(:colspan="operatorDetail && operatorDetail.self_operate == true ? '10' : '9'").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in memberList" :class="$helpers.rowClass(item)")
                      td
                        span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                      td
                        span.font-weight-bold(:title="item.account_id")
                          b-link.clickable(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                      td
                        span(:title="item.parent_id") {{ item.parent_id }}
                      td
                        span(:title="item.full_name") {{ item.full_name }}
                      td
                        span(:title="item.contact_phone") {{ item.contact_phone }}
                      td
                        span(:title="item.last_login_ip") {{ item.last_login_ip }}
                      td
                        span(v-if="item.outstanding_balance == 0" :title="$n(item.game_balance, 'currency')") {{ $n(item.game_balance, 'currency') }}
                        span(v-if="item.outstanding_balance != 0" :title="$n(item.game_balance, 'currency')") {{ $n(item.game_balance, 'currency') }}
                        span(:class="{'text-danger': item.outstanding_balance < 0  }" v-if="item.outstanding_balance != 0" :title="$n(item.outstanding_balance, 'currency')") ({{ $n(item.outstanding_balance, 'currency') }})
                      td
                        span(v-if="(operatorDetail && operatorDetail.self_operate == false) || item.status.toUpperCase() == 'FREEZE'" :title="item.status") {{ item.status }}
                        select(@change="changedMemberStatus(item, $event)" :value="item.status" v-else)
                          option(value="ACTIVE") {{ $t("ui.active") }}
                          option(value="BLOCK" :disabled="item.status.toUpperCase() == 'ACTIVE' || item.status.toUpperCase() == 'CLOSE'") {{ $t("ui.block") }}
                          option(value="CLOSE") {{ $t("ui.close") }}
                      td.actions(v-if="operatorDetail && operatorDetail.self_operate == true")
                        span
                          a.fa.fa-edit.text-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                        span
                          a.fa.fa-lock.text-warning(href="javascript:void(0)" @click="onResetPasswordMember(item)" :title="$t('ui.reset_password')")
                        span
                          a.fa.fa-sliders-h.text-secondary(href="javascript:void(0)" @click="onAdjust(item)" :title="$t('ui.adjust_balance')")
                        span
                          a.fa.fa-gift.text-warning(href="javascript:void(0)" @click="onAddMemberPromo(item)" :title="$t('ui.add_promo')")
                        span
                          a.fa.fa-money-bill-alt.text-info(href="javascript:void(0)" @click="onIssueBonus(item)" :title="$t('ui.issue_bonus')")
                        span
                          a.fas.fa-stream.text-info(href="javascript:void(0)" @click="onAddMemberPromoFB(item)" :title="$t('ui.livestream_bonus')")
                        span
                          a.fas.fa-ticket-alt.text-primary(href="javascript:void(0)" @click="onIssueTournament(item)" :title="$t('ui.issue_tournament')")
                        span
                          a.fas.fa-gamepad.text-info(href="javascript:void(0)" @click="onCheckMemberFreeSpin(item)" :title="$t('ui.check_free_spin')")
                        span
                          a.fas.fa-mobile-alt.text-secondary(href="javascript:void(0)" @click="onGetTac(item)" :title="$t('ui.get_tac')")
                        span
                          a.fas.fa-building.text-info(href="javascript:void(0)" @click="onGetBankTac(item)" :title="$t('ui.get_bank_tac')")
                        span(v-if="item.status.toUpperCase() == 'BLOCK'")
                          a.fa.fa-unlock.text-danger(href="javascript:void(0)" @click="onUnblock(item)" :title="$t('ui.unblock')")
                      td.text-right
                        span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    editmember(ref="editmember" :item="editSelectedMember" @clicked="afterEditMember" @failed="handleFailed")
    adjustmember(ref="adjustmember" :item="editSelectedMember" @clicked="afterAdjustMember" @failed="handleFailed")
    addmemberpromo(ref="addmemberpromo" :item="editSelectedMember" @clicked="afterAddMemberPromo" @failed="handleFailed")
    addmemberpromofb(ref="addmemberpromofb" :item="editSelectedMember" @clicked="afterAddMemberPromoFB" @failed="handleFailed")
    issuebonus(ref="issuebonus" :item="editSelectedMember" @clicked="afterIssueBonus" @failed="handleFailed")
    membersummary(ref="membersummary" :member="editSelectedMember" @failed="handleFailed")
    resetpasswordmember(ref="resetpasswordmember" :item="editSelectedMember" @clicked="afterResetPasswordMember" @failed="handleFailed")
    issuetournament(ref="issuetournament" :item="editSelectedMember" @clicked="afterIssueTournament" @failed="handleFailed")
    checkmemberfreespin(ref="checkmemberfreespin" :item="editSelectedMember" @failed="handleFailed")
    gettac(ref="gettac" :item="editSelectedMember" @failed="handleFailed")
    getbanktac(ref="getbanktac" :item="editSelectedMember" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editmember from "@/components/member/editMember.vue";
import adjustmember from "@/components/member/adjustMember.vue";
import addmemberpromo from "@/components/member/addMemberPromo.vue";
import addmemberpromofb from "@/components/member/addMemberPromoFB.vue";
import issuebonus from "@/components/member/issueBonus.vue";
import membersummary from "@/components/member/memberSummary.vue";
import resetpasswordmember from "@/components/member/resetPasswordMember.vue";
import issuetournament from "@/components/member/issueTournament.vue";
import checkmemberfreespin from "@/components/member/checkMemberFreeSpin.vue";
import gettac from "@/components/member/getTac.vue";
import getbanktac from "@/components/member/getBankTac.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editmember,
    adjustmember,
    addmemberpromo,
    addmemberpromofb,
    issuebonus,
    membersummary,
    resetpasswordmember,
    issuetournament,
    checkmemberfreespin,
    gettac,
    getbanktac,
  },
  data: () => ({
    loading: false,
    memberList: [],
    operatorDetail: null,
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedMember: null,
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  mounted: function() {
    this.getMemberList(true);
    this.getOperatorDetail();
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getMemberList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    onEdit(e) {
      this.editSelectedMember = e;
      this.$refs.editmember.$refs.editMember.show();
    },
    onAdjust(e) {
      this.editSelectedMember = e;
      this.$refs.adjustmember.$refs.adjustMember.show();
    },
    onResetPasswordMember(e) {
      this.editSelectedMember = e;
      this.$refs.resetpasswordmember.$refs.resetPasswordMember.show();
    },
    onAddMemberPromo(e) {
      this.editSelectedMember = e;
      this.$refs.addmemberpromo.$refs.addMemberPromo.show();
    },
    onAddMemberPromoFB(e) {
      this.editSelectedMember = e;
      this.$refs.addmemberpromofb.$refs.addMemberPromoFB.show();
    },
    onIssueBonus(e) {
      this.editSelectedMember = e;
      this.$refs.issuebonus.$refs.issueBonus.show();
    },
    onInfo(e) {
      this.editSelectedMember = e;
      this.$refs.membersummary.$refs.memberSummary.show();
    },
    onIssueTournament(e) {
      this.editSelectedMember = e;
      this.$refs.issuetournament.$refs.issueTournament.show();
    },
    onCheckMemberFreeSpin(e) {
      this.editSelectedMember = e;
      this.$refs.checkmemberfreespin.$refs.checkMemberFreeSpin.show();
    },
    onGetTac(e) {
      this.editSelectedMember = e;
      this.$refs.gettac.$refs.getTac.show();
    },
    onGetBankTac(e) {
      this.editSelectedMember = e;
      this.$refs.getbanktac.$refs.getBankTac.show();
    },
    getOperatorDetail: function() {
      let url = config.accountAgentDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.account[0].parent_id,
        target_account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.operatorDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    checkMemberSearchCriteria: function () {
      if (this.search.trim() != '') {
        if (this.filterBy == "full_name" && this.search.trim().length < 3) {
          return false;
        }
      }

      return true;
    },
    getMemberList: function(isSearch) {
      if (this.checkMemberSearchCriteria()) {
        let url = config.memberListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          source_account_id: this.$store.getters.accountId,
          target_account_id: this.$store.getters.accountId,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if (this.search.trim() != '') {
          if (this.filterBy == "account_id") {
            json.search_id = this.search.trim();
          } else if (this.filterBy == "full_name") {
            json.full_name = this.search.trim();
          }
        }

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.memberList = response.data.dt;
                  this.totalRow = this.memberList.length > 0 ? this.memberList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.memberList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.fullNameMinThreeChar"), "error");
      }
    },
    onUnblock: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_member_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblock(item);
          }
        });
    },
    confirmUnblock: function(item) {
      let url = config.accountUnblockMemberUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: item.account_id
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                item.status = "ACTIVE";
                this.$helpers.showDialog(this.$t("ui.unblock_member"), this.$t("message.success"), "success");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedMemberStatus: function(member, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_member_status_confirm", { name: member.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMemberStatus(member, eventStatus.srcElement.value);
          } else {
            eventStatus.srcElement.value = member.status;
          }
        });
    },
    confirmMemberStatus: function(member, status) {
      let url = config.statusUpdateMemberUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        target_account_id: member.account_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                member.status = status;
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterResetPasswordMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterAdjustMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.adjust_member"), this.$t("message.success"), "success");
    },
    afterAddMemberPromo: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.add_member_promo"), this.$t("message.success"), "success");
    },
    afterAddMemberPromoFB: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.issue_livestream_bonus"), this.$t("message.success"), "success");
    },
    afterIssueBonus: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.issue_bonus"), this.$t("message.success"), "success");
    },
    afterEditMember: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_member"), this.$t("message.success"), "success");
    },
    afterIssueTournament: function() {
      this.getMemberList();
      this.$helpers.showDialog(this.$t("ui.combine.issue_tournament"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getMemberList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>